import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useFont } from '../contexts/FontContext';
import { useScrollToTop } from '../hooks/useScrollToTop';
import Logo from './Logo';

export default function Footer() {
  const { theme } = useTheme();
  const { font } = useFont();
  const navigate = useNavigate();
  useScrollToTop();

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200" style={{ fontFamily: font.family }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4 cursor-pointer" onClick={() => navigate('/')}>
              <Logo />
            </div>
            <p className="text-gray-600 mb-4">
              Formation professionnelle et accompagnement VAE dans le domaine de la petite enfance.
            </p>
            <a
              href="mailto:loustaletformation@gmail.com"
              className={`text-${theme.text} hover:text-${theme.primary} transition-colors`}
            >
              loustaletformation@gmail.com
            </a>
          </div>

        </div>

        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-4 text-sm">
            <button onClick={() => navigate('/cgu')} className="text-gray-500 hover:text-gray-700">
              Conditions générales de vente
            </button>
            <span className="hidden md:inline text-gray-300">•</span>
            <button onClick={() => navigate('/mentions-legales')} className="text-gray-500 hover:text-gray-700">
              Mentions légales
            </button>
            <span className="hidden md:inline text-gray-300">•</span>
            <button onClick={() => navigate('/politique-de-confidentialite')} className="text-gray-500 hover:text-gray-700">
              Politique de confidentialité
            </button>
            <span className="hidden md:inline text-gray-300">•</span>
            <p className="text-gray-500">
            © {currentYear} L'oustalet formation. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}